/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Tool usage filter option type
 */
export const OptionTypes = {
  HostedServers: "hosted_servers",
  ShadowServers: "shadow_servers",
  Gateways: "gateways",
  Users: "users",
  Clients: "clients",
} as const;
/**
 * Tool usage filter option type
 */
export type OptionTypes = ClosedEnum<typeof OptionTypes>;

/**
 * Payload for target-aware MCP and tool usage filter options
 */
export type GetToolUsageFilterOptionsPayload = {
  /**
   * Start time in ISO 8601 format
   */
  from: Date;
  /**
   * Filter option types to include. Empty means all option types.
   */
  optionTypes?: Array<OptionTypes> | undefined;
  /**
   * End time in ISO 8601 format
   */
  to: Date;
};

/** @internal */
export const OptionTypes$outboundSchema: z.ZodMiniEnum<typeof OptionTypes> = z
  .enum(OptionTypes);

/** @internal */
export type GetToolUsageFilterOptionsPayload$Outbound = {
  from: string;
  option_types?: Array<string> | undefined;
  to: string;
};

/** @internal */
export const GetToolUsageFilterOptionsPayload$outboundSchema: z.ZodMiniType<
  GetToolUsageFilterOptionsPayload$Outbound,
  GetToolUsageFilterOptionsPayload
> = z.pipe(
  z.object({
    from: z.pipe(z.date(), z.transform(v => v.toISOString())),
    optionTypes: z.optional(z.array(OptionTypes$outboundSchema)),
    to: z.pipe(z.date(), z.transform(v => v.toISOString())),
  }),
  z.transform((v) => {
    return remap$(v, {
      optionTypes: "option_types",
    });
  }),
);

export function getToolUsageFilterOptionsPayloadToJSON(
  getToolUsageFilterOptionsPayload: GetToolUsageFilterOptionsPayload,
): string {
  return JSON.stringify(
    GetToolUsageFilterOptionsPayload$outboundSchema.parse(
      getToolUsageFilterOptionsPayload,
    ),
  );
}
